export enum TABS {
  ACCEPTANCE = 'acceptance',
  NOMENCLATURE = 'nomenclature',
  IMPORT_ERRORS = 'import_errors',
  SHIPMENTS = 'shipments',
  SETTINGS = 'settings',
}

export const isWarehouseTab = (tab?: string): tab is TABS => {
  return !!tab && Object.values(TABS).includes(tab as TABS);
};
